import { useTranslation } from 'react-i18next';

import { Section } from '@/pages/themes/theme-editor/Section';

export function Advanced() {
  const [t] = useTranslation();

  return <Section sectionNameKey="advanced">{t('keywords.coming_soon')}</Section>;
}
